import { useCallback } from 'react';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { dashboardCommentCreated } from '../../../utils/analytics/events/dashboard/events';
import { assertNotNil } from '../../../utils/types';
import { IDashboardEventSubParams } from '../../../utils/analytics/events/dashboard/types';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';
import { ICommentInputInfo } from '../../../components/Conversations/types';

const useTrackDashboardCommentCreate = (
  newCommentTarget: IDashboardEventSubParams['newCommentTarget'],
) => {
  const { track } = useAnalytics();
  const dashboard = useDashboardSelector('dashboard');
  assertNotNil(dashboard);

  return useCallback(
    (commentInputInfo: ICommentInputInfo) => {
      track(
        dashboardCommentCreated(dashboard, {
          newCommentTarget,
          ...commentInputInfo,
        }),
      );
    },
    [dashboard, newCommentTarget, track],
  );
};

export default useTrackDashboardCommentCreate;
